import React from "react";
import { setKey } from '../../api/insurance-takers/actions'
import moment from "moment";
import { registerLocale } from "react-datepicker";
import is from 'date-fns/locale/is';
import { updateContractIdentification } from "../../api/id/actions";
import { fetchTilbod } from "../../api/offers/actions";
import { Spinner } from "../../utils";
registerLocale('is', is)


class TinUpdater extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                tinOrSsn: '',
            }
        }
        this.onConfirm = this.onConfirm.bind(this)
        this.tinOrSsn = React.createRef()

    }

    validateForm() {
        let errors = this.state.errors
        let valid = true;
        let today = moment.utc(new Date());

        Object.keys(errors).forEach(key => {

            switch (key) {
                case 'tinOrSsn':
                    errors.tinOrSsn = ''
                    let tinOrSsnValue = this.tinOrSsn.current.value
                    if (tinOrSsnValue === '') {
                        errors.tinOrSsn = 'Skilyrði að fylla út'
                        valid = false;
                    } else if  (!/[0-9]{9}/.test(tinOrSsnValue)) {
                        errors.tinOrSsn = 'Vinsamlegast sláðu inn gilt TIN/SSN númer (9 tölustafir)';
                        valid = false;
                    }
                    break;

                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onConfirm(event) {
        event.preventDefault()
        if (this.validateForm()) {
            let newInfo = {
                insuranceTakerId: this.props.insuranceTakerId,
                tinOrSsn: this.tinOrSsn.current.value,
            }
            Promise.resolve(this.props.dispatch(updateContractIdentification(this.props.contractId, newInfo)))
            .then(() => {
                this.props.dispatch(fetchTilbod(this.props.contractId, false))
            })
        }
    }


    render() {
        return (
            <form className="contract-form">
                <div className={`${this.state.errors.tinOrSsn.length > 0 ? 'error' : ''} form-row align-items-center`}>
                    <label htmlFor="addId-tinOrSsn" className="col-sm-3 col-form-label">
                        SSN/TIN
                        {this.state.errors.tinOrSsn.length > 0 ?
                            <span className="error"> ({this.state.errors.tinOrSsn}) </span> : ''
                        }
                    </label>
                    <div className="col-sm-6">
                        <input ref={this.tinOrSsn} id="addId-tinOrSsn" type="text" className="form-control text-right" name="tinOrSsn" placeholder="Sláðu inn SSN eða TIN númer" />
                    </div>
                    <div className="col-sm-3">
                        <button type="button" className="btn btn-primary" onClick={this.onConfirm}>{this.props.identificationState.isUpdating && <Spinner />} Staðfesta</button>
                    </div>
                </div>
            </form>
        )
    }
}

export default TinUpdater

TinUpdater.defaultProps = {
}